import { Injectable } from "@angular/core";
import { Jurisdiction } from "@obg/core.config";
import { map as lodashMap } from "lodash-es";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CommonContentClient } from "../content/common-content.client";

import { processRawBanner } from "./banner/banner.utils";
import { CommonContent, CommonContentItem, CommonContentParams, CommonContentType } from "./common-content.model";
import { processMobileRegistrationPromotion } from "./mobile-registration-promotion/mobile-registration-promotion.util";
import { processRegistrationPromotion } from "./registration-promotion/registration-promotion.util";
@Injectable({
	providedIn: "root",
})
export class CommonContentService {
	constructor(private client: CommonContentClient) {}

	get(
		params: CommonContentParams,
		searchParams?: { isLoggedIn: boolean; jurisdiction: Jurisdiction | undefined }
	): Observable<CommonContent[]> {
		const documentName = params.presenceType ? `${params.presenceType}${params.contentType}` : params.contentType;

		return this.client
			.getCommonContent(documentName, searchParams)
			.pipe(map((result) => lodashMap(result, (item) => this.processCommonContent(item, params.contentType))));
	}

	processCommonContent(item: CommonContentItem, type: CommonContentType): CommonContent {
		switch (type) {
			case CommonContentType.Main:
			case CommonContentType.Promotional:
			case CommonContentType.Banner:
				return processRawBanner(item);
			case CommonContentType.DesktopCasinoRegistrationPromotion:
			case CommonContentType.DesktopCommonRegistrationPromotion:
			case CommonContentType.DesktopSportsbookRegistrationPromotion:
			case CommonContentType.DesktopVirtualSportsRegistrationPromotion:
			case CommonContentType.DesktopLiveCasinoRegistrationPromotion:
			case CommonContentType.DesktopPokerRegistrationPromotion:
			case CommonContentType.DesktopTurkishPokerRegistrationPromotion:
				return processRegistrationPromotion(item);
			case CommonContentType.MobileCommonRegistrationPromotion:
			case CommonContentType.MobileCasinoRegistrationPromotion:
			case CommonContentType.MobileVirtualSportsRegistrationPromotion:
			case CommonContentType.MobileSportsbookRegistrationPromotion:
			case CommonContentType.MobilePokerRegistrationPromotion:
			case CommonContentType.MobileLiveCasinoRegistrationPromotion:
				return processMobileRegistrationPromotion(item);
		}
	}
}
